import axios from 'axios';

import {
	Loading,
	Message
} from 'element-ui';

import { md5Encrypt } from '@/utils/MD5.js';


// 接口共用地址
// import BASE_URL from '../config/env.js'
import { BASE_URL } from '@/config/env.js';
axios.defaults.timeout = 100000;
axios.defaults.baseURL = BASE_URL;

/**
 * http request 拦截器
 */
axios.interceptors.request.use(
	(config) => {
		// startLoading()
		// config.headers = {
		// 	"Authorization": 'Bearer ' + localStorage.getItem("Token"),
		// };
		// endLoading()
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

/**
 * http response 拦截器
 */
axios.interceptors.response.use(
	(response) => {
		// console.log(response)
		if (response.data) {
			try {
			
				if (response.status == 200 && response.data.message) {
					if (response.data.code == 200) {
						// Message({
						// 	message: response.data.message,
						// 	type: 'success',
						// 	duration: 2000,
						// 	showClose: true
						// });
					} else {
						// Message({
						// 	message: response.data.message,
						// 	type: 'error',
						// 	duration: 2000,
						// 	showClose: true
						// });
					}
				}
				if (response.status != 200 && response.data.message) {
					// Message({
					// 	message: response.data.message,
					// 	type: 'warning',
					// 	duration: 2000,
					// 	showClose: true
					// });
				}
			} catch (e) {
				console.log('捕获到异常：', e);
			}

			return Promise.resolve(response);
		}
	},
	(error) => {
		// console.log("请求出错：", error);
		let msg = '';
		let msgCh = '';
		if (error && error.response) {
			switch (error.response.status) {
				case 404:
					msg = 'Request error, the resource was not found';
					msgCh = '请求错误,未找到该资源';
					break;
				case 500:
					msg = 'Server Error';
					msgCh = '服务器错误';
					break;
				case 504:
					msg = 'Gateway Timeout';
					msgCh = '网关超时';
					break;
				default:
					msg = error.response.data.msg;
					msgCh = error.response.data.msgCh;
			}
			// Message({
			// 	message: msgCh,
			// 	type: 'error',
			// 	duration: 5000,
			// 	showClose: true
			// });
			return Promise.reject(error);
		} else if (error && error.message) {
			// 处理网络错误，包括CORS错误
			if (error.message.includes('Network Error') || error.message.includes('CORS')) {
				msg = 'Network Error: CORS or network connectivity issue';
				msgCh = '网络错误：跨域访问被拒绝或网络连接失败';
			} else {
				msg = error.message;
				msgCh = error.message;
			}
			// Message({
			// 	message: msgCh,
			// 	type: 'error',
			// 	duration: 5000,
			// 	showClose: true
			// });
			return Promise.reject(error);
		}
		return Promise.reject(error);
	}
);


export function httpPost(url, data) {
	// console.log(data);
	let dataArraydataArray = { ...data };
	const now = new Date();
	// 转换为北京时间
	const beijingTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' }));

	// 格式化输出 yyyyMMddHHmmss
	const year = beijingTime.getFullYear();
	const month = String(beijingTime.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
	const day = String(beijingTime.getDate()).padStart(2, '0');
	const hour = String(beijingTime.getHours()).padStart(2, '0');
	const minute = String(beijingTime.getMinutes()).padStart(2, '0');
	const second = String(beijingTime.getSeconds()).padStart(2, '0');

	const formattedTime = `${year}${month}${day}${hour}${minute}${second}`;
	dataArraydataArray.timestamp = formattedTime
	// 95f9fa6d49v442add05f1c54d63749eda
	let XSign = md5Encrypt(JSON.stringify(dataArraydataArray) + '95f9fa6d49v442add05f1c54d63749eda');

	return axios.request({
		url: url,
		method: 'POST',
		data: dataArraydataArray,
		headers: {
			'Access-Control-Allow-Origin': '*',
			'Content-Type': 'application/json',
			// 验证签名
			'X-Sign': XSign,
			// 时间戳字段

			'X-TIMESTAMP': formattedTime,
		}
	});
}
export function httpPut(url, data) {
	return axios.put(
		url,
		data,
	)
}
export function httpPostUpload(url, data) {
	return axios.request({
		url: url,
		method: 'POST',
		data: data,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

export function httpGet(url, data) {
	let dataArraydataArray = { ...data };
	const now = new Date();
	// 转换为北京时间
	const beijingTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' }));

	// 格式化输出 yyyyMMddHHmmss
	const year = beijingTime.getFullYear();
	const month = String(beijingTime.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
	const day = String(beijingTime.getDate()).padStart(2, '0');
	const hour = String(beijingTime.getHours()).padStart(2, '0');
	const minute = String(beijingTime.getMinutes()).padStart(2, '0');
	const second = String(beijingTime.getSeconds()).padStart(2, '0');

	const formattedTime = `${year}${month}${day}${hour}${minute}${second}`;


	dataArraydataArray.timestamp = formattedTime

	const SECRET_KEY = '95f9fa6d49v442add05f1c54d63749eda';  // 签名密钥
	// 1. 对对象的键进行排序
	const sortedParams = Object.keys(dataArraydataArray).sort().reduce((result, key) => {
		result[key] = dataArraydataArray[key];
		return result;
	}, {});
	console.log(sortedParams);
	
	// 4. 加入密钥
	const stringToSign = JSON.stringify(sortedParams) + SECRET_KEY;
	// console.log(stringToSign);
	// dd05f1c54d63749eda95f9fa6d491142a
	let XSign = md5Encrypt(stringToSign);
	// console.log(XSign);
	// console.log(dataArraydataArray);
	return axios.get(
		url, {
		headers: {
			'Content-Type': 'application/json',

			// 验证签名
			'X-Sign': XSign,
			// 时间戳字段

			'X-TIMESTAMP': formattedTime,
		},
		params: sortedParams,
	},
	)
}

export function httpDelete(url, data) {
	return axios.delete(
		url, {
		headers: {
			'Content-Type': 'application/json',
		},
		data: data,
	},

	)
}
export const URL = BASE_URL



//获取 授权地址
export const getApprove = data => httpGet('/game/api/getApprove', data);
// 获取订单接口
export const getQueryOrderById = data => httpGet('/game/api/queryOrderById', data);




//生成进度
export const progress = data => httpPost('/game/api/progress', data);

//查询代理
export const getAgentInfo = data => httpPost('/game/api/getAgentInfo', data);

//转账
export const transfer = data => httpPost('/game/api/transfer', data);

